webpackJsonp([114276838955818,60335399758886],{

/***/ 121:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(180);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(121);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var PropTypes = _interopDefault(__webpack_require__(2));
	var hoistNonReactStatics = _interopDefault(__webpack_require__(88));
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	// https://github.com/styled-components/styled-components/blob/e05b3fe247e9d956bcde786cec376e32afb85bca/src/utils/create-broadcast.js
	var createBroadcast = function createBroadcast(initialState) {
	  var listeners = {};
	  var id = 0;
	  var state = initialState;
	
	  function publish(nextState) {
	    state = nextState;
	
	    for (var key in listeners) {
	      var listener = listeners[key];
	
	      if (listener === undefined) {
	        continue;
	      }
	
	      listener(state);
	    }
	  }
	
	  function subscribe(listener) {
	    var currentId = id;
	    listeners[currentId] = listener;
	    id += 1;
	    listener(state);
	    return currentId;
	  }
	
	  function unsubscribe(unsubID) {
	    listeners[unsubID] = undefined;
	  }
	
	  return {
	    publish: publish,
	    subscribe: subscribe,
	    unsubscribe: unsubscribe
	  };
	};
	
	var _contextTypes;
	
	var channel = '__EMOTION_THEMING__';
	var contextTypes = (_contextTypes = {}, _contextTypes[channel] = PropTypes.object, _contextTypes);
	
	// adapted from styled-components' ThemeProvider
	// https://github.com/styled-components/styled-components/blob/4503cab5b86aa9ef8314c5baa360a2fbb4812485/src/models/ThemeProvider.js
	var isPlainObject = function isPlainObject(test) {
	  return Object.prototype.toString.call(test) === '[object Object]';
	};
	
	var ThemeProvider =
	/*#__PURE__*/
	function (_Component) {
	  _inheritsLoose(ThemeProvider, _Component);
	
	  function ThemeProvider() {
	    var _this;
	
	    _this = _Component.call(this) || this;
	    _this.getTheme = _this.getTheme.bind(_this);
	    return _this;
	  }
	
	  var _proto = ThemeProvider.prototype;
	
	  _proto.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
	    // with the outer theme
	    if (this.context[channel] !== undefined) {
	      this.unsubscribeToOuterId = this.context[channel].subscribe(function (theme) {
	        _this2.outerTheme = theme;
	      });
	    }
	
	    this.broadcast = createBroadcast(this.getTheme(this.props.theme));
	  };
	
	  _proto.getChildContext = function getChildContext() {
	    var _ref;
	
	    return _ref = {}, _ref[channel] = {
	      subscribe: this.broadcast.subscribe,
	      unsubscribe: this.broadcast.unsubscribe
	    }, _ref;
	  };
	
	  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.theme !== nextProps.theme) {
	      this.broadcast.publish(this.getTheme(nextProps.theme));
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    var themeContext = this.context[channel];
	
	    if (themeContext !== undefined) {
	      themeContext.unsubscribe(this.unsubscribeToOuterId);
	    }
	  }; // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
	
	
	  _proto.getTheme = function getTheme(theme) {
	    if (typeof theme === 'function') {
	      var mergedTheme = theme(this.outerTheme);
	
	      if (!isPlainObject(mergedTheme)) {
	        throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
	      }
	
	      return mergedTheme;
	    }
	
	    if (!isPlainObject(theme)) {
	      throw new Error('[ThemeProvider] Please make your theme prop a plain object');
	    }
	
	    if (this.outerTheme === undefined) {
	      return theme;
	    }
	
	    return _extends({}, this.outerTheme, theme);
	  };
	
	  _proto.render = function render() {
	    if (!this.props.children) {
	      return null;
	    }
	
	    return React__default.Children.only(this.props.children);
	  };
	
	  return ThemeProvider;
	}(React.Component);
	
	ThemeProvider.childContextTypes = contextTypes;
	ThemeProvider.contextTypes = contextTypes;
	
	var withTheme = function withTheme(Component$$1) {
	  var componentName = Component$$1.displayName || Component$$1.name || 'Component';
	
	  var WithTheme =
	  /*#__PURE__*/
	  function (_React$Component) {
	    _inheritsLoose(WithTheme, _React$Component);
	
	    function WithTheme() {
	      return _React$Component.apply(this, arguments) || this;
	    }
	
	    var _proto = WithTheme.prototype;
	
	    _proto.componentWillMount = function componentWillMount() {
	      var _this = this;
	
	      var themeContext = this.context[channel];
	
	      if (themeContext === undefined) {
	        // eslint-disable-next-line no-console
	        console.error('[withTheme] Please use ThemeProvider to be able to use withTheme');
	        return;
	      }
	
	      this.unsubscribeId = themeContext.subscribe(function (theme) {
	        _this.setState({
	          theme: theme
	        });
	      });
	    };
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      if (this.unsubscribeId !== -1) {
	        this.context[channel].unsubscribe(this.unsubscribeId);
	      }
	    };
	
	    _proto.render = function render() {
	      return React__default.createElement(Component$$1, _extends({
	        theme: this.state.theme
	      }, this.props));
	    };
	
	    return WithTheme;
	  }(React__default.Component);
	
	  WithTheme.displayName = "WithTheme(" + componentName + ")";
	  WithTheme.contextTypes = contextTypes;
	  return hoistNonReactStatics(WithTheme, Component$$1);
	};
	
	exports.ThemeProvider = ThemeProvider;
	exports.withTheme = withTheme;
	exports.channel = channel;
	exports.contextTypes = contextTypes;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 264:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var react = __webpack_require__(1);
	var emotionUtils = __webpack_require__(19);
	var emotion = __webpack_require__(25);
	var PropTypes = _interopDefault(__webpack_require__(2));
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var _contextTypes;
	
	var channel = '__EMOTION_THEMING__';
	var contextTypes = (_contextTypes = {}, _contextTypes[channel] = PropTypes.object, _contextTypes);
	
	/* global codegen */
	function setTheme(theme) {
	  this.setState({
	    theme: theme
	  });
	}
	
	function componentWillMount() {
	  if (this.context[channel] !== undefined) {
	    this.unsubscribe = this.context[channel].subscribe(setTheme.bind(this));
	  }
	}
	
	function componentWillUnmount() {
	  if (this.unsubscribe !== undefined) {
	    this.context[channel].unsubscribe(this.unsubscribe);
	  }
	}
	
	var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|accept|acceptCharset|accessKey|action|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan)|(on[A-Z].*)|((data|aria)-.*))$/;
	var testOmitPropsOnStringTag = emotionUtils.memoize(function (key) {
	  return reactPropsRegex.test(key);
	});
	
	var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
	  return key !== 'theme' && key !== 'innerRef';
	};
	
	var testAlwaysTrue = function testAlwaysTrue() {
	  return true;
	};
	
	var omitAssign = function omitAssign(testFn, target) {
	  var i = 2;
	  var length = arguments.length;
	
	  for (; i < length; i++) {
	    var source = arguments[i];
	    var key = void 0;
	
	    for (key in source) {
	      if (testFn(key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var createStyled = function createStyled(tag, options) {
	  if (false) {
	    if (tag === undefined) {
	      throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
	    }
	  }
	
	  var identifierName;
	  var stableClassName;
	  var staticClassName;
	
	  if (options !== undefined) {
	    identifierName = options.label;
	    stableClassName = options.target;
	    staticClassName = options.e;
	  }
	
	  var isReal = tag.__emotion_real === tag;
	  var baseTag = staticClassName === undefined ? isReal && tag.__emotion_base || tag : tag;
	  var omitFn = typeof baseTag === 'string' && baseTag.charAt(0) === baseTag.charAt(0).toLowerCase() ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
	  return function (strings) {
	    var styles = isReal && tag[emotionUtils.STYLES_KEY] || [];
	
	    if (identifierName !== undefined) {
	      styles = styles.concat("label:" + identifierName + ";");
	    }
	
	    if (staticClassName === undefined) {
	      for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        interpolations[_key - 1] = arguments[_key];
	      }
	
	      if (strings == null || strings.raw === undefined) {
	        styles = styles.concat(strings, interpolations);
	      } else {
	        styles = interpolations.reduce(function (array, interp, i) {
	          return array.concat(interp, strings[i + 1]);
	        }, styles.concat(strings[0]));
	      }
	    }
	
	    var Styled =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(Styled, _Component);
	
	      function Styled() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      var _proto = Styled.prototype;
	
	      _proto.render = function render() {
	        var props = this.props,
	            state = this.state;
	        this.mergedProps = omitAssign(testAlwaysTrue, {}, props, {
	          theme: state !== null && state.theme || props.theme || {}
	        });
	        var className = '';
	        var classInterpolations = [];
	
	        if (props.className) {
	          if (staticClassName === undefined) {
	            className += emotion.getRegisteredStyles(classInterpolations, props.className);
	          } else {
	            className += props.className + " ";
	          }
	        }
	
	        if (staticClassName === undefined) {
	          className += emotion.css.apply(this, styles.concat(classInterpolations));
	        } else {
	          className += staticClassName;
	        }
	
	        if (stableClassName !== undefined) {
	          className += " " + stableClassName;
	        }
	
	        return react.createElement(baseTag, omitAssign(omitFn, {}, props, {
	          className: className,
	          ref: props.innerRef
	        }));
	      };
	
	      return Styled;
	    }(react.Component);
	
	    Styled.prototype.componentWillMount = componentWillMount;
	    Styled.prototype.componentWillUnmount = componentWillUnmount;
	    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
	    Styled.contextTypes = contextTypes;
	    Styled[emotionUtils.STYLES_KEY] = styles;
	    Styled.__emotion_base = baseTag;
	    Styled.__emotion_real = Styled;
	    Styled[emotionUtils.TARGET_KEY] = stableClassName;
	
	    Styled.withComponent = function (nextTag, nextOptions) {
	      return createStyled(nextTag, nextOptions !== undefined ? omitAssign(testAlwaysTrue, {}, options, nextOptions) : options)(styles);
	    };
	
	    return Styled;
	  };
	};
	
	exports['default'] = createStyled;
	Object.keys(emotion).forEach(function (key) { exports[key] = emotion[key]; });
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var pseudoStyle = __webpack_require__(6);
	module.exports = pseudoStyle('active')({
	  color: 'colors',
	  backgroundColor: 'colors',
	  borderColor: 'colors',
	  boxShadow: 'shadows'
	});

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var responsiveStyle = __webpack_require__(4);
	module.exports = responsiveStyle('alignItems', 'align');

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var responsiveStyle = __webpack_require__(4);
	module.exports = responsiveStyle('alignSelf', 'alignSelf');

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var style = __webpack_require__(5);
	
	module.exports = style({
	  prop: 'borderColor',
	  key: 'colors'
	});

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var style = __webpack_require__(5);
	
	module.exports = style({
	  prop: 'borderRadius',
	  key: 'radii',
	  numberToPx: true
	});

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var style = __webpack_require__(5);
	
	var getDirectionProp = function getDirectionProp(template) {
	  return function (dir) {
	    return template(dir);
	  };
	};
	var getWidthProp = getDirectionProp(function (dir) {
	  return 'border' + dir + 'Width';
	});
	var getStyleProp = getDirectionProp(function (dir) {
	  return 'border' + dir + 'Style';
	});
	
	var getDirections = function getDirections(props) {
	  var directions = [];
	  if (props.borderTop) directions.push('Top');
	  if (props.borderRight) directions.push('Right');
	  if (props.borderBottom) directions.push('Bottom');
	  if (props.borderLeft) directions.push('Left');
	  return directions.length ? directions : null;
	};
	
	module.exports = function (props) {
	  var directions = getDirections(props);
	  var borderWidths = directions ? directions.map(function (dir) {
	    return style({
	      key: 'borderWidths',
	      prop: 'borderWidth',
	      cssProperty: getWidthProp(dir),
	      numberToPx: true
	    })(props);
	  }) : [style({
	    key: 'borderWidths',
	    prop: 'borderWidth',
	    numberToPx: true
	  })(props)];
	
	  var borderStyles = directions ? directions.map(function (dir) {
	    return _defineProperty({}, getStyleProp(dir), 'solid');
	  }) : [{ borderStyle: 'solid' }];
	
	  return props.borderWidth || props.borderWidth === 0 ? Object.assign.apply(Object, [{}].concat(_toConsumableArray(borderWidths), _toConsumableArray(borderStyles))) : null;
	};

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var style = __webpack_require__(5);
	
	module.exports = style({
	  prop: 'boxShadow',
	  key: 'shadows'
	});

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	
	var cleanElement = function cleanElement(Component) {
	  return function (_React$Component) {
	    _inherits(Cleaned, _React$Component);
	
	    function Cleaned() {
	      _classCallCheck(this, Cleaned);
	
	      return _possibleConstructorReturn(this, (Cleaned.__proto__ || Object.getPrototypeOf(Cleaned)).apply(this, arguments));
	    }
	
	    _createClass(Cleaned, [{
	      key: 'render',
	      value: function render() {
	        var next = {};
	        var keys = Object.keys(Cleaned.propTypes || {});
	        for (var key in this.props) {
	          if (keys.includes(key)) continue;
	          next[key] = this.props[key];
	        }
	
	        return React.createElement(Component, next);
	      }
	    }]);
	
	    return Cleaned;
	  }(React.Component);
	};
	
	module.exports = cleanElement;

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _require = __webpack_require__(3),
	    get = _require.get,
	    breaks = _require.breaks,
	    merge = _require.merge,
	    arr = _require.arr,
	    dec = _require.dec,
	    media = _require.media;
	
	var REG = /^color|bg$/;
	
	module.exports = function (props) {
	  var keys = Object.keys(props).filter(function (key) {
	    return REG.test(key);
	  });
	  var bp = breaks(props);
	  var palette = get(props, 'theme.colors', {});
	
	  return keys.map(function (key) {
	    var val = props[key];
	    var prop = properties[key] || key;
	
	    if (!Array.isArray(val)) {
	      return _defineProperty({}, prop, cx(palette)(val));
	    }
	
	    return val.map(cx(palette)).map(dec(prop)).map(media(bp)).reduce(merge, {});
	  }).reduce(merge, {});
	};
	
	var cx = function cx(obj) {
	  return function (n) {
	    return get(obj, n + '', n);
	  };
	};
	
	var properties = {
	  bg: 'backgroundColor'
	};

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

	"use strict";
	
	var breakpoints = [40, 52, 64];
	
	var space = [0, 8, 16, 32, 64];
	
	var fontSizes = [12, 14, 16, 20, 24, 32, 48, 64, 72];
	
	module.exports = {
	  breakpoints: breakpoints,
	  space: space,
	  fontSizes: fontSizes
	};

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var pseudoStyle = __webpack_require__(6);
	module.exports = pseudoStyle('disabled', 'disabledStyle')({
	  color: 'colors',
	  backgroundColor: 'colors',
	  borderColor: 'colors',
	  boxShadow: 'shadows'
	});

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var responsiveStyle = __webpack_require__(4);
	module.exports = responsiveStyle('flexDirection');

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var responsiveStyle = __webpack_require__(4);
	module.exports = responsiveStyle('flexWrap', 'wrap', 'wrap');

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var responsiveStyle = __webpack_require__(4);
	module.exports = responsiveStyle('flex');

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var pseudoStyle = __webpack_require__(6);
	module.exports = pseudoStyle('focus')({
	  color: 'colors',
	  backgroundColor: 'colors',
	  borderColor: 'colors',
	  boxShadow: 'shadows'
	});

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(3),
	    get = _require.get,
	    is = _require.is,
	    arr = _require.arr,
	    num = _require.num,
	    px = _require.px,
	    breaks = _require.breaks,
	    dec = _require.dec,
	    media = _require.media,
	    merge = _require.merge;
	
	var _require2 = __webpack_require__(7),
	    fontSizes = _require2.fontSizes;
	
	module.exports = function (props) {
	  var n = is(props.fontSize) ? props.fontSize : props.fontSize || props.f;
	  if (!is(n)) return null;
	
	  var scale = get(props, 'theme.fontSizes', fontSizes);
	
	  if (!Array.isArray(n)) {
	    return {
	      fontSize: fx(scale)(n)
	    };
	  }
	
	  var bp = breaks(props);
	
	  return n.map(fx(scale)).map(dec('fontSize')).map(media(bp)).reduce(merge, {});
	};
	
	var fx = function fx(scale) {
	  return function (n) {
	    return num(n) ? px(scale[n] || n) : n;
	  };
	};

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var style = __webpack_require__(5);
	
	module.exports = style({
	  prop: 'fontWeight',
	  key: 'fontWeights'
	});

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var pseudoStyle = __webpack_require__(6);
	module.exports = pseudoStyle('hover')({
	  color: 'colors',
	  backgroundColor: 'colors',
	  borderColor: 'colors',
	  boxShadow: 'shadows'
	});

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// core
	var space = __webpack_require__(66);
	var width = __webpack_require__(69);
	var fontSize = __webpack_require__(59);
	var color = __webpack_require__(53);
	
	// low-level style function creators
	var style = __webpack_require__(5);
	var responsiveStyle = __webpack_require__(4);
	var pseudoStyle = __webpack_require__(6);
	
	// extras
	var textAlign = __webpack_require__(67);
	var lineHeight = __webpack_require__(64);
	var fontWeight = __webpack_require__(60);
	var letterSpacing = __webpack_require__(63);
	var alignItems = __webpack_require__(46);
	var justifyContent = __webpack_require__(62);
	var flexWrap = __webpack_require__(56);
	var flexDirection = __webpack_require__(55);
	var flex = __webpack_require__(57);
	var alignSelf = __webpack_require__(47);
	var borderRadius = __webpack_require__(49);
	var borderColor = __webpack_require__(48);
	var borderWidth = __webpack_require__(50);
	var boxShadow = __webpack_require__(51);
	var hover = __webpack_require__(61);
	var focus = __webpack_require__(58);
	var active = __webpack_require__(45);
	var disabled = __webpack_require__(54);
	
	// other
	var theme = __webpack_require__(68);
	var propTypes = __webpack_require__(20);
	var cleanElement = __webpack_require__(52);
	var removeProps = __webpack_require__(65);
	var util = __webpack_require__(3);
	var constants = __webpack_require__(7);
	
	module.exports = {
	  space: space,
	  width: width,
	  fontSize: fontSize,
	  color: color,
	  style: style,
	  responsiveStyle: responsiveStyle,
	  pseudoStyle: pseudoStyle,
	  textAlign: textAlign,
	  lineHeight: lineHeight,
	  fontWeight: fontWeight,
	  letterSpacing: letterSpacing,
	  alignItems: alignItems,
	  justifyContent: justifyContent,
	  flexWrap: flexWrap,
	  flexDirection: flexDirection,
	  flex: flex,
	  alignSelf: alignSelf,
	  borderRadius: borderRadius,
	  borderColor: borderColor,
	  borderWidth: borderWidth,
	  boxShadow: boxShadow,
	  hover: hover,
	  focus: focus,
	  active: active,
	  disabled: disabled,
	  theme: theme,
	  propTypes: propTypes,
	  cleanElement: cleanElement,
	  removeProps: removeProps,
	  util: util,
	  constants: constants
	};

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var responsiveStyle = __webpack_require__(4);
	module.exports = responsiveStyle('justifyContent', 'justify');

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var style = __webpack_require__(5);
	
	module.exports = style({
	  prop: 'letterSpacing',
	  key: 'letterSpacings',
	  numberToPx: true
	});

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var style = __webpack_require__(5);
	
	module.exports = style({
	  prop: 'lineHeight',
	  key: 'lineHeights'
	});

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var PropTypes = __webpack_require__(2);
	
	var responsive = PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array]);
	
	var responsiveBoolean = PropTypes.oneOfType([PropTypes.bool, PropTypes.array]);
	
	var numberOrString = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
	
	var width = {
	  width: responsive,
	  w: responsive
	};
	
	var space = {
	  m: responsive,
	  mt: responsive,
	  mr: responsive,
	  mb: responsive,
	  ml: responsive,
	  mx: responsive,
	  my: responsive,
	  p: responsive,
	  pt: responsive,
	  pr: responsive,
	  pb: responsive,
	  pl: responsive,
	  px: responsive,
	  py: responsive
	};
	
	var fontSize = {
	  fontSize: responsive,
	  f: responsive
	};
	
	var color = {
	  color: responsive,
	  bg: responsive
	};
	
	var textAlign = {
	  align: responsive
	};
	
	var fontWeight = {
	  fontWeight: numberOrString
	};
	
	var alignItems = {
	  align: responsive
	};
	
	var justifyContent = {
	  justify: responsive
	};
	
	var flexWrap = {
	  wrap: responsiveBoolean
	};
	
	var flexDirection = {
	  flexDirection: responsive
	};
	
	var flex = {
	  flex: responsive
	};
	
	var alignSelf = {
	  alignSelf: responsive
	};
	
	var borderRadius = {
	  borderRadius: numberOrString
	};
	
	var borderWidth = {
	  borderWidth: numberOrString,
	  borderTop: PropTypes.bool,
	  borderRight: PropTypes.bool,
	  borderBottom: PropTypes.bool,
	  borderLeft: PropTypes.bool
	};
	
	var borderColor = {
	  borderColor: PropTypes.string
	};
	
	var boxShadow = {
	  boxShadow: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	
	var hover = {
	  hover: PropTypes.object
	};
	
	var focus = {
	  focus: PropTypes.object
	};
	
	var active = {
	  active: PropTypes.object
	};
	
	var disabled = {
	  disabledStyle: PropTypes.object
	};
	
	var propTypes = {
	  width: width,
	  space: space,
	  fontSize: fontSize,
	  color: color,
	  textAlign: textAlign,
	  fontWeight: fontWeight,
	  alignItems: alignItems,
	  justifyContent: justifyContent,
	  flexWrap: flexWrap,
	  flexDirection: flexDirection,
	  flex: flex,
	  alignSelf: alignSelf,
	  borderRadius: borderRadius,
	  borderWidth: borderWidth,
	  borderColor: borderColor,
	  boxShadow: boxShadow,
	  hover: hover,
	  focus: focus,
	  active: active,
	  disabled: disabled
	};
	
	module.exports = propTypes;

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _require = __webpack_require__(3),
	    get = _require.get,
	    px = _require.px;
	
	module.exports = function (pseudoclass, prop) {
	  return function () {
	    var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return function (props) {
	      var style = props[prop || pseudoclass];
	      var numberToPx = keys.numberToPx || {};
	      for (var key in style) {
	        var toPx = numberToPx[key];
	
	        if (!keys[key] && !toPx) continue;
	        var themeKey = [keys[key], style[key]].join('.');
	        style[key] = get(props.theme, themeKey, style[key]);
	
	        if (toPx) style[key] = px(style[key]);
	      }
	
	      return _defineProperty({}, '&:' + pseudoclass, style);
	    };
	  };
	};

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var propTypes = __webpack_require__(20);
	
	var blacklist = Object.keys(propTypes).reduce(function (a, key) {
	  return [].concat(_toConsumableArray(a), _toConsumableArray(Object.keys(propTypes[key])));
	}, []);
	
	module.exports = function (props) {
	  var next = {};
	
	  for (var key in props) {
	    if (blacklist.includes(key)) continue;
	    next[key] = props[key];
	  }
	
	  return next;
	};

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _require = __webpack_require__(3),
	    get = _require.get,
	    is = _require.is,
	    arr = _require.arr,
	    num = _require.num,
	    px = _require.px,
	    breaks = _require.breaks,
	    dec = _require.dec,
	    media = _require.media,
	    merge = _require.merge;
	
	module.exports = function () {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return function (props) {
	    // support for legacy API
	    var arg = args[0],
	        _prop = args[1],
	        _bool = args[2];
	
	    var _ref = typeof arg === 'string' ? { cssProperty: arg, prop: _prop, boolValue: _bool } : arg,
	        cssProperty = _ref.cssProperty,
	        prop = _ref.prop,
	        boolValue = _ref.boolValue,
	        key = _ref.key,
	        numberToPx = _ref.numberToPx;
	
	    prop = prop || cssProperty;
	    var n = props[prop];
	    if (!is(n)) return null;
	
	    var bp = breaks(props);
	    var scale = get(props, ['theme', key || prop].join('.'), {});
	    var sx = function sx(val) {
	      return get(scale, '' + val, numberToPx ? px(val) : val);
	    };
	
	    if (!Array.isArray(n)) {
	      return _defineProperty({}, cssProperty, sx(bool(boolValue)(n)));
	    }
	
	    var val = arr(n);
	    return val.map(bool(boolValue)).map(sx).map(dec(cssProperty)).map(media(bp)).reduce(merge, {});
	  };
	};
	
	var bool = function bool(val) {
	  return function (n) {
	    return n === true ? val : n;
	  };
	};

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _require = __webpack_require__(3),
	    get = _require.get,
	    arr = _require.arr,
	    px = _require.px,
	    neg = _require.neg,
	    num = _require.num,
	    breaks = _require.breaks,
	    dec = _require.dec,
	    media = _require.media,
	    merge = _require.merge;
	
	var _require2 = __webpack_require__(7),
	    space = _require2.space;
	
	var REG = /^[mp][trblxy]?$/;
	
	module.exports = function (props) {
	  var keys = Object.keys(props).filter(function (key) {
	    return REG.test(key);
	  }).sort();
	  var bp = breaks(props);
	  var sc = get(props, 'theme.space', space);
	
	  return keys.map(function (key) {
	    var val = props[key];
	    var p = getProperties(key);
	
	    if (!Array.isArray(val)) {
	      return p.reduce(function (a, b) {
	        return Object.assign(a, _defineProperty({}, b, mx(sc)(val)));
	      }, {});
	    }
	
	    return arr(val).map(mx(sc)).map(dec(p)).map(media(bp)).reduce(merge, {});
	  }).reduce(merge, {});
	};
	
	var mx = function mx(scale) {
	  return function (n) {
	    if (!num(n)) {
	      return n;
	    }
	
	    var value = scale[Math.abs(n)] || Math.abs(n);
	    if (!num(value)) {
	      return value;
	    }
	
	    return px(value * (neg(n) ? -1 : 1));
	  };
	};
	
	var getProperties = function getProperties(key) {
	  var _key$split = key.split(''),
	      _key$split2 = _slicedToArray(_key$split, 2),
	      a = _key$split2[0],
	      b = _key$split2[1];
	
	  var prop = properties[a];
	  var dirs = directions[b] || [''];
	  return dirs.map(function (dir) {
	    return prop + dir;
	  });
	};
	
	var properties = {
	  m: 'margin',
	  p: 'padding'
	};
	
	var directions = {
	  t: ['Top'],
	  r: ['Right'],
	  b: ['Bottom'],
	  l: ['Left'],
	  x: ['Left', 'Right'],
	  y: ['Top', 'Bottom']
	};

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _require = __webpack_require__(3),
	    get = _require.get,
	    is = _require.is,
	    px = _require.px;
	
	module.exports = function (_ref) {
	  var key = _ref.key,
	      prop = _ref.prop,
	      cssProperty = _ref.cssProperty,
	      numberToPx = _ref.numberToPx;
	  return function (props) {
	    var n = props[prop];
	    if (!is(n)) return null;
	    var val = get(props, ['theme', key, n].join('.'), n);
	    var value = numberToPx ? px(val) : val;
	
	    return _defineProperty({}, cssProperty || prop, value);
	  };
	};

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var responsiveStyle = __webpack_require__(4);
	module.exports = responsiveStyle('textAlign', 'align');

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// theme getter
	var _require = __webpack_require__(3),
	    get = _require.get;
	
	module.exports = function (keys, fallback) {
	  return function (props) {
	    return get(props.theme, keys, fallback);
	  };
	};

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var _require = __webpack_require__(7),
	    breakpoints = _require.breakpoints;
	
	var is = function is(n) {
	  return n !== undefined && n !== null;
	};
	var num = function num(n) {
	  return typeof n === 'number' && !isNaN(n);
	};
	var px = function px(n) {
	  return num(n) ? n + 'px' : n;
	};
	var em = function em(n) {
	  return num(n) ? n + 'em' : n;
	};
	var neg = function neg(n) {
	  return n < 0;
	};
	var arr = function arr(n) {
	  return Array.isArray(n) ? n : [n];
	};
	
	var get = function get(obj, path, fallback) {
	  return path.split('.').reduce(function (a, b) {
	    return a && a[b] ? a[b] : null;
	  }, obj) || fallback;
	};
	
	var mq = function mq(n) {
	  return '@media screen and (min-width: ' + em(n) + ')';
	};
	
	var breaks = function breaks(props) {
	  return [null].concat(_toConsumableArray(get(props, 'theme.breakpoints', breakpoints).map(mq)));
	};
	
	var dec = function dec(props) {
	  return function (val) {
	    return arr(props).reduce(function (acc, prop) {
	      return acc[prop] = val, acc;
	    }, {});
	  };
	};
	
	var media = function media(bp) {
	  return function (d, i) {
	    return is(d) ? bp[i] ? _defineProperty({}, bp[i], d) : d : null;
	  };
	};
	
	var merge = function merge(a, b) {
	  return Object.assign({}, a, b, Object.keys(b).reduce(function (obj, key) {
	    return Object.assign(obj, _defineProperty({}, key, a[key] !== null && _typeof(a[key]) === 'object' ? merge(a[key], b[key]) : b[key]));
	  }, {}));
	};
	
	// keeping for backwards-compatibility only
	var idx = function idx(keys, obj) {
	  return get(obj, keys.join('.')) || null;
	};
	
	module.exports = {
	  get: get,
	  is: is,
	  px: px,
	  em: em,
	  neg: neg,
	  num: num,
	  arr: arr,
	  idx: idx,
	  breaks: breaks,
	  media: media,
	  dec: dec,
	  merge: merge,
	  mq: mq
	};

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(3),
	    is = _require.is,
	    arr = _require.arr,
	    num = _require.num,
	    px = _require.px,
	    breaks = _require.breaks,
	    dec = _require.dec,
	    media = _require.media,
	    merge = _require.merge;
	
	module.exports = function (props) {
	  var n = is(props.width) ? props.width : props.width || props.w;
	  if (!is(n)) return null;
	
	  if (!Array.isArray(n)) {
	    return {
	      width: wx(n)
	    };
	  }
	
	  var bp = breaks(props);
	
	  return n.map(wx).map(dec('width')).map(media(bp)).reduce(merge, {});
	};
	
	var wx = function wx(n) {
	  return !num(n) || n > 1 ? px(n) : n * 100 + '%';
	};

/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.45c3c8c4.svg";

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(11);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _logo = __webpack_require__(588);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _colors = __webpack_require__(16);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _index = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    'a',
	    { href: '#' },
	    _react2.default.createElement(
	      _index.Flex,
	      { bg: _colors2.default.accent, p: '5rem' },
	      _react2.default.createElement(_index.Img, { m: 'auto', src: _logo2.default, width: [1, 3 / 4, 3 / 4], maxWidth: '800px' })
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FlexibleLink = exports.A = exports.Input = exports.Li = exports.Nav = exports.SemanticList = exports.Img = exports.Link = exports.H2 = exports.H1 = exports.P = exports.Flex = exports.Box = exports.height = exports.display = exports.maxWidth = exports.wrap = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactEmotion = __webpack_require__(11);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _styledSystem = __webpack_require__(26);
	
	var _gatsbyLink = __webpack_require__(85);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var wrap = exports.wrap = (0, _styledSystem.responsiveStyle)({
	  prop: 'wrap',
	  cssProperty: 'flexWrap'
	});
	
	var maxWidth = exports.maxWidth = (0, _styledSystem.responsiveStyle)({
	  prop: 'maxWidth',
	  cssProperty: 'maxWidth'
	});
	var display = exports.display = (0, _styledSystem.responsiveStyle)({
	  prop: 'display',
	  cssProperty: 'display'
	});
	var height = exports.height = (0, _styledSystem.responsiveStyle)({
	  prop: 'height',
	  cssProperty: 'height'
	});
	
	var Box = /*#__PURE__*/exports.Box = (0, _reactEmotion2.default)('div', {
	  target: 'css-1h1so8w0'
	})('display:flex;flex-direction:column;', maxWidth, ' ', _styledSystem.space, ' ', _styledSystem.width, ' ', _styledSystem.fontSize, ' ', _styledSystem.color, ' ', _styledSystem.alignItems, ';');
	
	var Flex = /*#__PURE__*/exports.Flex = (0, _reactEmotion2.default)('div', {
	  target: 'css-1h1so8w1'
	})('display:flex;', _styledSystem.alignItems, ' ', maxWidth, ' ', _styledSystem.justifyContent, ' ', wrap, ' ', _styledSystem.space, ' ', _styledSystem.width, ' ', _styledSystem.fontSize, ' ', _styledSystem.fontWeight, ' ', _styledSystem.color, ';');
	
	var P = /*#__PURE__*/exports.P = (0, _reactEmotion2.default)('p', {
	  target: 'css-1h1so8w2'
	})(maxWidth, ' ', _styledSystem.textAlign, ' ', _styledSystem.space, ' ', _styledSystem.width, ' ', _styledSystem.fontSize, ' ', _styledSystem.fontWeight, ' ', _styledSystem.color, ';');
	
	var H1 = /*#__PURE__*/exports.H1 = (0, _reactEmotion2.default)('h1', {
	  target: 'css-1h1so8w3'
	})(maxWidth, ' ', _styledSystem.textAlign, ' ', _styledSystem.space, ' ', _styledSystem.width, ' ', _styledSystem.fontSize, ' ', _styledSystem.fontWeight, ' ', _styledSystem.color, ';');
	
	var H2 = /*#__PURE__*/exports.H2 = (0, _reactEmotion2.default)('h1', {
	  target: 'css-1h1so8w4'
	})(maxWidth, ' ', _styledSystem.textAlign, ' ', _styledSystem.space, ' ', _styledSystem.width, ' ', _styledSystem.fontSize, ' ', _styledSystem.fontWeight, ' ', _styledSystem.color, ';');
	var Link = /*#__PURE__*/exports.Link = (0, _reactEmotion2.default)(_gatsbyLink2.default, {
	  target: 'css-1h1so8w5'
	})(maxWidth, ' ', _styledSystem.textAlign, ' ', _styledSystem.space, ' ', _styledSystem.width, ' ', _styledSystem.fontSize, ' ', _styledSystem.fontWeight, ' ', _styledSystem.color, ';');
	var Img = /*#__PURE__*/exports.Img = (0, _reactEmotion2.default)('img', {
	  target: 'css-1h1so8w6'
	})(maxWidth, ' ', _styledSystem.textAlign, ' ', _styledSystem.space, ' ', _styledSystem.width, ' ', _styledSystem.fontSize, ' ', _styledSystem.fontWeight, ' ', _styledSystem.color, ';');
	
	var SemanticList = /*#__PURE__*/exports.SemanticList = (0, _reactEmotion2.default)('ul', {
	  target: 'css-1h1so8w7'
	})('display:flex;list-style:none;', display, ' ', maxWidth, ' ', _styledSystem.alignItems, ' ', _styledSystem.justifyContent, ' ', _styledSystem.space, ' ', _styledSystem.width, ' ', _styledSystem.fontSize, ' ', _styledSystem.fontWeight, ' ', _styledSystem.color, ';');
	
	var Nav = /*#__PURE__*/exports.Nav = (0, _reactEmotion2.default)('nav', {
	  target: 'css-1h1so8w8'
	})('display:flex;', display, ' ', maxWidth, ' ', _styledSystem.alignItems, ' ', _styledSystem.justifyContent, ' ', _styledSystem.space, ' ', _styledSystem.width, ' ', _styledSystem.fontSize, ' ', _styledSystem.fontWeight, ' ', _styledSystem.color, ';');
	
	var Li = /*#__PURE__*/exports.Li = (0, _reactEmotion2.default)('li', {
	  target: 'css-1h1so8w9'
	})(display, ' ', maxWidth, ' ', _styledSystem.alignItems, ' ', _styledSystem.justifyContent, ' ', _styledSystem.space, ' ', _styledSystem.width, ' ', _styledSystem.fontSize, ' ', _styledSystem.fontWeight, ' ', _styledSystem.color, ';');
	
	var Input = /*#__PURE__*/exports.Input = (0, _reactEmotion2.default)('input', {
	  target: 'css-1h1so8w10'
	})(height, ' ', display, ' ', maxWidth, ' ', _styledSystem.alignItems, ' ', _styledSystem.justifyContent, ' ', _styledSystem.space, ' ', _styledSystem.width, ' ', _styledSystem.fontSize, ' ', _styledSystem.fontWeight, ' ', _styledSystem.color, ';');
	
	var A = /*#__PURE__*/exports.A = (0, _reactEmotion2.default)('a', {
	  target: 'css-1h1so8w11'
	})(maxWidth, ' ', _styledSystem.textAlign, ' ', _styledSystem.space, ' ', _styledSystem.width, ' ', _styledSystem.fontSize, ' ', _styledSystem.fontWeight, ' ', _styledSystem.color, ';');
	
	var FlexibleLink = function FlexibleLink(_ref) {
	  var to = _ref.to,
	      children = _ref.children,
	      href = _ref.href,
	      props = _objectWithoutProperties(_ref, ['to', 'children', 'href']);
	
	  if (to) {
	    return _react2.default.createElement(
	      Link,
	      _extends({ to: to }, props),
	      children
	    );
	  } else {
	    return _react2.default.createElement(
	      A,
	      _extends({ href: href }, props),
	      children
	    );
	  }
	};
	exports.FlexibleLink = FlexibleLink;

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(11);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _emotion = __webpack_require__(25);
	
	var _colors = __webpack_require__(16);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _media = __webpack_require__(183);
	
	var _media2 = _interopRequireDefault(_media);
	
	var _Layout = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var navLink = /*#__PURE__*/(0, _emotion.css)('&:hover{color:#1c86f2;}');
	
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      children = _ref.children,
	      href = _ref.href;
	
	  return _react2.default.createElement(
	    'li',
	    null,
	    _react2.default.createElement(
	      _Layout.FlexibleLink,
	      { mx: 2, to: to, color: 'black', className: navLink },
	      children
	    )
	  );
	};
	
	var Navigation = function (_Component) {
	  _inherits(Navigation, _Component);
	
	  function Navigation() {
	    _classCallCheck(this, Navigation);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Navigation.prototype.render = function render() {
	    return _react2.default.createElement(
	      _Layout.Nav,
	      { fontSize: 3 },
	      _react2.default.createElement(
	        _Layout.SemanticList,
	        { display: 'flex', ml: 'auto', px: [3, 3, 4], my: 3 },
	        _react2.default.createElement(
	          NavLink,
	          { to: '/' },
	          'Home'
	        ),
	        _react2.default.createElement(
	          NavLink,
	          { to: '/manifesto' },
	          'Manifesto'
	        ),
	        _react2.default.createElement(
	          NavLink,
	          { href: '/source', target: '_blank' },
	          'Source'
	        )
	      )
	    );
	  };
	
	  return Navigation;
	}(_react.Component);
	
	exports.default = Navigation;
	module.exports = exports['default'];

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(11);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _styledSystem = __webpack_require__(26);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _emotionTheming = __webpack_require__(263);
	
	var _Navigation = __webpack_require__(179);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _Footer = __webpack_require__(178);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _colors = __webpack_require__(16);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _normalize = __webpack_require__(264);
	
	var _normalize2 = _interopRequireDefault(_normalize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import Intercom, { IntercomAPI } from 'react-intercom'
	
	(0, _reactEmotion.injectGlobal)('@import url(\'https://fonts.googleapis.com/css?family=Lato:100,100i,300,300i,400,400i,700,700i,900,900i\');*{', '\n      font-family:Lato,sans-serif;box-sizing:border-box;};a{text-decoration:none;color:', _colors2.default.accent, ';};a:hover{cursor:pointer;text-decoration:underline;};h1,h2,h3,h4,h5,h6,p{color:', _colors2.default.secondary, '};');
	/* eslint-enable */
	
	/* eslint-disable */
	// import 'typeface-lato'
	
	var FontConfig = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'css-192h7dd0'
	})(_styledSystem.fontSize, ';');
	
	var theme = {
	  breakpoints: ['675px', '1000px']
	};
	
	var Layout = function Layout(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    _emotionTheming.ThemeProvider,
	    { theme: theme },
	    _react2.default.createElement(
	      FontConfig,
	      { fontSize: [2, 3, 4] },
	      _react2.default.createElement(_Navigation2.default, null),
	      children()
	    )
	  );
	};
	
	Layout.propTypes = {
	  children: _propTypes2.default.func.isRequired
	};
	
	exports.default = Layout;
	module.exports = exports['default'];

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var colors = {
	  primary: '#fff',
	  secondary: '#222',
	  accent: '#1c86f2',
	  subtle: 'rgba(0, 0, 0, 0.5)'
	};
	
	exports.default = colors;
	module.exports = exports['default'];

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactEmotion = __webpack_require__(11);
	
	var sizes = {
	  large: 1024,
	  mid: 832,
	  small: 640
	
	  // Iterate through the sizes and create a media template
	};var media = Object.keys(sizes).reduce(function (acc, label) {
	  acc[label] = function () {
	    return (/*#__PURE__*/(0, _reactEmotion.css)('@media (min-width:', sizes[label] / 16, 'em){', /*#__PURE__*/_reactEmotion.css.apply(undefined, arguments), ';}')
	    );
	  };
	
	  return acc;
	}, {});
	
	exports.default = media;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-aa5717147d051a5561a1.js